const FormTitle = ({ prop, text }) => {
  return (
    <h4 className="text-center my-0">
      {`${prop ? "Modificar" : "Crear"} ${text}`}
    </h4>
  );
};

export default FormTitle;
